<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar icon="fal fa-home" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption">{{ printZip }}&nbsp;{{ printKana }}</v-list-item-subtitle>
      <v-list-item-title>{{ printAddress }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="11" class="px-3">
        <v-text-field required
          v-model="form.zip"
          label="郵便番号"
          :rules="rules.zip"
          mask="###-####"
          :loading="isSearching"
          @keypress.enter.prevent="search"
        />
      </v-col>
      <v-col cols="1">
        <v-btn fab depressed x-small
          color="secondary"
          class="mt-3"
        >
          <v-icon small>fa-search</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="px-3">
        <v-select
          v-model="form.pref"
          label="都道府県"
          :items="getPrefItems"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field ref="city"
          v-model="form.city"
          label="市町村区"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field ref="number"
          v-model="form.number"
          label="番地・建物"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.kana"
          label="ふりがな"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutGuardiansAddress',
  components: {
    UtilConfirmModal,
    AbtItemAvatar
  },
  props: [
    'gid',
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'home',
        status: {
          loading: false
        }
      },
      form: {
        id: '',
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      },
      rules: {
        zip: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.data.zip &&
        this.$props.data.pref != null &&
        this.$props.data.city != null &&
        this.$props.data.number != null &&
        this.$props.data.kana != null
      ) {
        this.$set(this, 'form', {
          valid: true,
          id: this.$props.data.id,
          zip: this.$props.data.zip,
          pref: this.$props.data.pref,
          city: this.$props.data.city,
          number: this.$props.data.number,
          kana: this.$props.data.kana
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? this.$props.data.id : '',
          type: this.config.type
        }
      })
    },
    search: function () {
      if (this.form.zip.length === 7 && !this.config.status.searching) {
        this.$set(this.config.status, 'searching', true)
        this.axios.get(this.$url.zip + this.form.zip).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            let data = res.data.data
            this.$set(this.form, 'pref', data.pref)
            this.$set(this.form, 'city', data.city)
            this.$set(this.form, 'number', data.town)
            this.$set(this.config.status, 'searching', false)
            this.$refs.number.focus()
            this.$store.dispatch('notifier/addSMessage', {
              title: '住所が見つかりました',
              message: data.pref + data.city + data.town
            })
          } else {
            this.$store.dispatch('notifier/addAlert', {
              title: '住所検索失敗',
              message: this.$error.zip.search.unmatch
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    remove: function () {
      if (
        this.$props.data &&
        this.$props.data.id &&
        this.$props.gid
      ) {
        this.$refs.confirm.open({
          title: '住所の削除',
          message: (
            this.$props.data &&
            this.$props.data.pref &&
            this.$props.data.city &&
            this.$props.data.number
          ) ? [
              'この住所を削除してもよろしいですか？',
              '<br/>',
              this.$props.data.pref,
              this.$props.data.city,
              this.$props.data.number
            ].join('') : '',
          callback: () => {
            console.log('delete')
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(this.$url.api + 'about/delete/address', {
                id: this.$props.data.id,
                cid: this.$props.gid
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$emit('emit', {
                    action: 'removeAddress',
                    data: res.data.data.id ? res.data.data.id : ''
                  })
                }
              })
            })
          }
        })
      }
    },
    getForm: function () {
      return this.form
    }
  },
  watch: {
    'form.zip': function (v) {
      this.form.zip = v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) })
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.$props.data.id)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.$props.data.id
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.$props.data.id
      )
    },
    printZip () {
      return (
        this.$props.data &&
        this.$props.data.zip
      ) ? ('〒' + this.$props.data.zip.substr(0, 3) + '-' + this.$props.data.zip.substr(3)) : ''
    },
    printKana () {
      return (
        this.$props.data &&
        this.$props.data.kana
      ) ? this.$props.data.kana : ''
    },
    printAddress () {
      return (
        this.$props.data &&
        this.$props.data.pref &&
        this.$props.data.city &&
        this.$props.data.number
      ) ? [
          this.$props.data.pref,
          this.$props.data.city,
          this.$props.data.number
        ].join('') : ''
    },
    getPrefItems () {
      return Object.keys(this.$mango.prefs)
    }
  }
}
</script>
